export const scoreMap = [
  {name: "极高", clazz: "extHigh", color: "#f00", level: 5, gradient: "rgba(255, 0, 0, 0.21)"},
  {name: "高", clazz: "high", color: "#f90", level: 4, gradient: "rgba(255, 153, 0, 0.21)"},
  {name: "中", clazz: "medium", color: "#fff627", level: 3, gradient: "rgba(255, 246, 39, 0.21)"},
  {name: "低", clazz: "low", color: "#00ff66", level: 2, gradient: "rgba(0, 173, 48, 0.21)"},
  {name: "极低", clazz: "extLow", color: "#00fdee", level: 1, gradient: "rgba(0, 253, 238, 0.21)"}
];

export const levelMap = [
  {code: "000701", clazz: "extHigh", name: "特别重大", color: "#f00", level: 1},
  {code: "000702", clazz: "high", name: "重大", color: "#f90", level: 2},
  {code: "000703", clazz: "medium", name: "较大", color: "#fff627", level: 3},
  {code: "000704", clazz: "low", name: "一般", color: "#00ff66", level: 4}
];

export const loopColor = [
  "#722ed1", "#eb2f96", "#2f54eb", "#1890ff", "#13c2c2", "#52c41a", "#fadb14", "#faad14", "#f5222d"
];
export const loopColorSec = [
  "#2ec7c9", "#b6a2de", "#5ab1ef", "#ffb980", "#d87a80", "#8d98b3", "#e5cf0d", "#97b552", "#95706d", "#dc69aa"
];

export const smoothColor = [
  "#00d1ff", "#4ae162", "#aa41e6"
];

export const levelColor = [
  "#fa00ff", "#ff0101", "#fff509", "#12d1fb"
];
